import { useEffect } from "react";

export default function DownloadRedirectPage() {
    const buildPublicCheckoutUrl = () => {
        const params = new URLSearchParams(window.location.search);
        const eventId = params.get("eventId");
        const refBy = params.get("refBy");

        if (!eventId) {
            return null;
        }

        const checkoutParams = new URLSearchParams();
        if (refBy) {
            checkoutParams.set("refBy", refBy);
        }

        const queryString = checkoutParams.toString();
        return `/events/${encodeURIComponent(eventId)}${queryString ? `?${queryString}` : ""}`;
    };

    const handleManualFallbackClick = () => {
        const publicCheckoutUrl = buildPublicCheckoutUrl();

        if (publicCheckoutUrl) {
            window.location.href = publicCheckoutUrl;
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const eventId = params.get("eventId");

        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        const iosUrl = `https://apps.apple.com/de/app/baila/id6462697936${eventId ? `?eventId=${eventId}` : ""}`;
        const androidUrl = `https://play.google.com/store/apps/details?id=com.baila_client${eventId ? `&eventId=${eventId}` : ""}`;

        if (/android/i.test(userAgent)) {
            window.location.href = androidUrl;
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            window.location.href = iosUrl;
        } else {
            window.location.href = iosUrl;
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const eventId = params.get("eventId");
        const refBy = params.get("refBy");

        const deepLinkUrl = `baila://app/event${eventId ? `?eventId=${eventId}` : ""}${refBy ? `${eventId ? "&" : "?"}refBy=${refBy}` : ""
            }`;

        const goToFallback = () => {
            const publicCheckoutUrl = buildPublicCheckoutUrl();
            if (publicCheckoutUrl) {
                window.location.href = publicCheckoutUrl;
                return;
            }

            handleManualFallbackClick();
        };

        let didHide = false;
        let fallbackTimer: number | undefined;

        const clearFallback = () => {
            if (fallbackTimer !== undefined) {
                window.clearTimeout(fallbackTimer);
                fallbackTimer = undefined;
            }
        };

        const onHide = () => {
            didHide = true;
            clearFallback();
        };

        document.addEventListener("visibilitychange", onHide);
        window.addEventListener("pagehide", onHide);
        window.addEventListener("blur", onHide);

        window.location.href = deepLinkUrl;

        fallbackTimer = window.setTimeout(() => {
            if (!didHide && document.visibilityState === "visible") {
                goToFallback();
            }
        }, 1600);

        return () => {
            clearFallback();
            document.removeEventListener("visibilitychange", onHide);
            window.removeEventListener("pagehide", onHide);
            window.removeEventListener("blur", onHide);
        };
    }, []);

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="flex flex-col items-center gap-3">
                <p className="text-lg">Opening the Baila app or continuing in web checkout…</p>
                <button
                    type="button"
                    onClick={handleManualFallbackClick}
                    className="rounded-full bg-white px-6 py-3 text-black hover:bg-neutral-100"
                >
                    Zum Web-Checkout
                </button>
            </div>
        </div>
    );
}
